import React, { Component } from "react";
import {
  Button,
  Table,
  Alert,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Select from 'react-select';
import * as nguoiDungKhoConstant from './constants'
import * as nguoiDungKhoAction from './actions'
import { customSelectStyles } from '../../lib/common';
import { storedb } from '../../views/client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { confirmAlert } from 'react-confirm-alert';

class NguoiDungKho extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    nguoiDungKhoListRequest: PropTypes.func,
    nguoiDungKhoUpdateRequest: PropTypes.func,
    nguoiDungKhoDetailRequest: PropTypes.func,
    nguoiDungKho: PropTypes.shape({
      list: PropTypes.array,
      resultUser: PropTypes.array,
      resultNgDung: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      StoreId: dbContext.getStoreId(),
      item: {},
      listKho: [],
      listNguoiDung: [],
      keyword: '',
      selectedOption: null,
      KhoId: 0,
      formError: []
    };
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  keyPress = (e) => {
    if(e.keyCode == 13){
       this.featchDetail()
    }
  }
  handleKhoChange = selectedOption => {
    this.setState({ selectedOption });
    this.setState({ KhoId: selectedOption.value }, () => {
      this.featchDetail();
    });
  };
  featchDetail = () => {
    const { nguoiDungKhoDetailRequest } = this.props
    var requestData = {
      keyword: this.state.keyword,
      StoreId: this.state.StoreId,
      KhoId: this.state.KhoId
    }
    return nguoiDungKhoDetailRequest(requestData);
  }
  fetchListKho = () => {
    const { nguoiDungKhoListRequest } = this.props

    var requestData = {
      StoreId: this.state.StoreId,
      keyword: this.state.keyword,
      status: 1,
      page: 1,
      per_page: 200
    };
    return nguoiDungKhoListRequest(requestData);
  }
  filterListUser = (event) => {
    var updatedList = this.props.nguoiDungKho.resultNgDung;
    updatedList = updatedList.filter(function (item) {
      return (item.TenDayDu.toLowerCase().search(event.target.value.toLowerCase()) !== -1) || (item.username.toLowerCase().search(event.target.value.toLowerCase()) !== -1);
    });
    this.setState({ listNguoiDung: updatedList })
  }
  UpdateAll = (res, flag) => {
    var formError = this.state.formError;
    formError = [];
    if (this.state.KhoId && this.state.KhoId > 0) {
      if (res && res.length > 0) {
        var requestData = {
          StoreId: this.state.StoreId,
          KhoId: this.state.KhoId || 0,
          UserIds: (flag == "add" ? res.map(function (item) { return item.UserId }) : []),
          NguoiDungKhoIds: (flag == "remove" ? res.map(function (item) { return item.NguoiDungKhoId }) : [])
        }
        this.props.nguoiDungKhoUpdateRequest(requestData);
      }
    } else {
      formError.RoleId = "Bạn chưa chọn nhóm";
    }
    this.setState({ formError: formError });
  }
  UpdateNguoiDung = (res, element) => {
    var formError = this.state.formError;
    formError = [];
    if (this.state.KhoId && this.state.KhoId > 0) {
      var requestData = {
        StoreId: this.state.StoreId,
        KhoId: this.state.KhoId || 0,
        UserIds: (res.UserId ? [res.UserId] : []),
        NguoiDungKhoIds: (res.NguoiDungKhoId ? [res.NguoiDungKhoId] : [])
      }
      this.props.nguoiDungKhoUpdateRequest(requestData);
    } else {
      formError.KhoId = "Bạn chưa chọn kho làm việc";
    }
    this.setState({ formError: formError });
  }
  processUpdateAllClick = (res, flag) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn cập nhật tất cả dữ liệu này không?
            </p>
            <button className="text-danger" onClick={() => {
              this.UpdateAll(res, flag)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  componentDidMount() {
    this.fetchListKho();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.nguoiDungKho.type == nguoiDungKhoConstant.NGUOIDUNGKHO_LIST_SUCCESS) {
      let { list, item } = nextProps.nguoiDungKho;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: this.BuildSelectOption(list)
      });
    } else if (nextProps.nguoiDungKho.type == nguoiDungKhoConstant.NGUOIDUNGKHO_UPDATE_SUCCESS) {
      this.featchDetail();
    } else if (nextProps.nguoiDungKho.type == nguoiDungKhoConstant.NGUOIDUNGKHO_DETAIL_SUCCESS) {
      let { resultNgDung } = nextProps.nguoiDungKho;
      this.setState({ listNguoiDung: resultNgDung })
    }
  }
  BuildSelectOption(list) {
    var options = [];
    if (list && list.length > 0) {
      list.map((item) => { options.push({ value: item.KhoId, label: item.Ten }) }
      );
    }
    return options;
  }
  render() {
    const { selectedOption, list, listNguoiDung } = this.state;
    const {
      handleSubmit,
      nguoiDungKho: {
        listRequesting,
        resultUser,
        resultNgDung
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div className="mb-3 border">
            <Select
              styles={customSelectStyles}
              placeholder="Chọn kho để thêm"
              value={selectedOption}
              onChange={this.handleKhoChange}
              options={list}
            />
            <em className="error invalid-feedback">{this.state.formError.KhoId}</em>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 row">
              <div className="col-sm-6">
                <Alert color="primary">Danh sách tài khoản chưa được thêm vào kho</Alert>
                <InputGroup>
                  <Input placeholder="Tên người dùng, tên tài khoản" 
                    onChange={this.handleSearchChange.bind(this, "keyword")} 
                    onKeyDown={e => this.keyPress(e)}
                    />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" onClick={handleSubmit(this.featchDetail)}>
                      <i className="fa fa-search"></i> Tìm kiếm
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" className="text-left">Tài khoản đăng nhập</th>
                      <th scope="col" className="text-left">Tên người dùng</th>
                      <th scope="col" width="50" className="text-left">
                        <ButtonExt
                          btnClass="text-primary"
                          iconClass="fa-arrow-right fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.processUpdateAllClick(resultUser, "add")}
                          permission={BtnPermissions.NguoiDungKho.ADD_OR_UPDATE} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultUser && !!resultUser.length && (
                      resultUser.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-left">{res.username}</td>
                          <td className="text-left">{res.TenDayDu}</td>
                          <td className="text-left">
                            <ButtonExt
                              btnClass="text-primary"
                              iconClass="fa-arrow-right fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateNguoiDung(res)}
                              permission={BtnPermissions.NguoiDungKho.ADD_OR_UPDATE} />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
              <div className="col-sm-6">
                <Alert color="success">Danh sách tài khoản đã được thêm vào kho</Alert>
                <InputGroup>
                  <Input placeholder="Tên người dùng, tên tài khoản" onChange={this.filterListUser} />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" >
                      <i className="fa fa-search"></i> Tìm kiếm
                      </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="50" className="text-center">
                        <ButtonExt
                          btnClass="text-danger"
                          iconClass="fa-arrow-left fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.processUpdateAllClick(listNguoiDung,"remove")}
                          permission={BtnPermissions.NguoiDungKho.ADD_OR_UPDATE} />
                      </th>
                      <th scope="col" className="text-left">Tài khoản đăng nhập</th>
                      <th scope="col" className="text-left">Tên người dùng</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listNguoiDung && !!listNguoiDung.length && (
                      listNguoiDung.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-center">
                            <ButtonExt
                              btnClass="text-danger"
                              iconClass="fa-arrow-left fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateNguoiDung(res)}
                              permission={BtnPermissions.NguoiDungKho.ADD_OR_UPDATE} />
                          </td>
                          <td className="text-left">{res.username}</td>
                          <td className="text-left">{res.TenDayDu}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  nguoiDungKho: state.nguoiDungKho,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  nguoiDungKhoListRequest: nguoiDungKhoAction.nguoiDungKhoListRequest,
  nguoiDungKhoUpdateRequest: nguoiDungKhoAction.nguoiDungKhoUpdateRequest,
  nguoiDungKhoDetailRequest: nguoiDungKhoAction.nguoiDungKhoDetailRequest,
})(NguoiDungKho)
const formed = reduxForm({
  form: 'nguoiDungKho',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/NguoiDungKho/NguoiDungKho.js